import React from 'react';
import PropTypes from 'prop-types';

const MoreHeader = ({ onClose }) => (
  <header className="vibe-more-header">
    <span className="vibe-more-header-spacer" aria-hidden="true" />
    <h2 className="vibe-more-title">More</h2>
    <button type="button" className="vibe-more-close" aria-label="Close" title="Close" onClick={onClose}>
      <i className="wb webconnect-times" aria-hidden="true" />
    </button>
  </header>
);

MoreHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default MoreHeader;
